import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridToolbar,
} from "@mui/x-data-grid";
import TablePagination from "@mui/material/TablePagination";
import NoDataTable from "../../assets/images/Empty box.svg";

import "./queryBuilderTable.css"

interface QueryBuilderTableProps {
  rows: any;
  columns: any;
  selectionModel: any;
  changeSortModel: (e: any) => void;
  perPage: any;
  handleChangePagination: (e: any) => void;
  count: any;
  page: any;
  handleChangePage: (e: any, d: any) => void;
  handleOnRowClick: (e: any, d: any) => void;
  tableHeader: any;
  getRowId?: any;
  height?: string;
  loading?: boolean;
  isExpanded?: boolean;
  message?: string
}

const QueryBuilderTable = ({
  rows,
  columns,
  selectionModel,
  changeSortModel,
  perPage,
  handleChangePagination,
  count,
  page,
  handleChangePage,
  handleOnRowClick,
  tableHeader,
  getRowId,
  isExpanded,
  loading = false,
  message
}: QueryBuilderTableProps) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const NoRowsOverlay = () => (
    <div className="no-rows-overlay">

      <div className="no-data-text">
        { "There is No data in Table"}
      </div>
      <img src={NoDataTable} alt="No Data" width={80} height={80} />
    </div>
  );

  const LoadingOverlay = () => {
    return (
      <div className="no-rows-overlay">
        <div className="no-data-text">Loading, please wait...</div>
        <img src={NoDataTable} alt="No Data" width={80} height={80} />

      </div>
    )
  }

  const getResponsiveHeight = () => {
    if (!isExpanded) return '31.85vh';
    if (windowHeight < 600) return '65vh';
    if (windowHeight < 700) return '70vh';
    if (windowHeight < 900) return '75vh';
    return '79vh';
  };

  return (
    <div className="query-builder-table">
      <div className="table-pagination-container">
        <TablePagination
          component="div"
          count={count || 0}
          page={page - 1}
          onPageChange={handleChangePage}
          rowsPerPage={perPage}
          onRowsPerPageChange={handleChangePagination}
          labelDisplayedRows={({ from, to, count }) =>
            `Showing ${from} to ${to} out of ${count}`
          }
          className="custom-pagination"
        />
      </div>

      <Box className="table-container">
        <DataGrid
          loading={loading}
          disableRowSelectionOnClick
          className="admin-table"
          rows={rows}
          getRowId={getRowId || ((row) => row.id)}
          rowHeight={40}
          columns={columns}
          disableColumnMenu
          slots={{
            pagination: null,
            noRowsOverlay: loading ? LoadingOverlay : NoRowsOverlay,
          }}
          sortModel={selectionModel}
          onSortModelChange={(model) => changeSortModel(model)}
          onRowClick={handleOnRowClick}
          style={{
            height: getResponsiveHeight()
          }}
        />
      </Box>
    </div>
  );
};

export default QueryBuilderTable;